import { forwardRef, ReactNode } from 'react';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { useTheme } from '@/providers/ThemeProvider/ThemeProvider';

import { TypographyVariant } from '../Typography/Typography.types';
import * as S from './ClickableChip.styles';

interface ClickableChipProps {
  id: string;
  label: string;
  isSelected?: boolean;
  isPremium?: boolean;
  icon?: ReactNode;
  onClick?: () => void;
  className?: string;
  titleVariant?: TypographyVariant;
  onBlur?: () => void;
}

export const ClickableChip = forwardRef<HTMLLabelElement, ClickableChipProps>(
  (
    {
      label,
      icon,
      isSelected = false,
      onClick,
      id,
      className,
      titleVariant = 'title5',
      isPremium = false,
      onBlur,
      ...rest
    },
    ref
  ) => {
    const { theme } = useTheme();

    const isLight = theme === 'light';

    return (
      <S.Chip
        ref={ref}
        {...rest}
        $isLight={isLight}
        $isPremium={isPremium}
        data-label="chip"
        $isSelected={isSelected}
        className={isSelected ? 'selected' : className}
      >
        {icon}
        <Typography variant={titleVariant}>{label}</Typography>
        <S.Input
          type="checkbox"
          value={id ?? label}
          checked={isSelected}
          readOnly={!onClick}
          onChange={onClick}
          onBlur={onBlur}
        />
      </S.Chip>
    );
  }
);

ClickableChip.displayName = 'ClickableChip';
